import { zIndexChart } from "@ui/Highcharts/BetterHighcharts";
import type { SelectedQuantity } from "../../useSelectedQuantities";

export function createQuantityThresholdPlotLine(
  quantity: SelectedQuantity["quantity"],
  filter: "min" | "max" | "maxStd",
  color: string,
): Highcharts.YAxisPlotLinesOptions {
  const threshold = filter === "maxStd" ? "max" : filter;
  const text = `${threshold.charAt(0).toUpperCase() + threshold.slice(1)}: ${
    quantity[`${filter}Metrology`] ?? ""
  } ${quantity.unit ?? ""}`;

  return {
    id: `${quantity.id}-${filter}-threshold`,
    dashStyle: "Dash",
    width: 1,
    value: quantity[`${filter}Metrology`] ?? undefined,
    color,
    label: {
      useHTML: true,
      y: filter === "min" ? 15 : -10,
      x: 0,
      text,
      style: {
        color,
        backgroundColor: "rgba(255, 255, 255, 0.75)",
        padding: "0.1em 0.25em",
        fontWeight: "bold",
        fontSize: "10px",
        pointerEvents: "none",
      },
    },
    zIndex: zIndexChart.plotLines,
  };
}
